import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Chip, Stack } from '@mui/material';

import { IcPlus } from '@/assets/images';
import { FormCard, Page, PageHeader, ViewItem } from '@/components';
import { useSearchPersist } from '@/components/DataGrid/hooks/useSearchPersist';
import { useBuildingInspectionContext } from '@/pages/Tools/BuildingInspection/BuildingInspectionContext';
import { FeesDataGrid } from '@/pages/Tools/BuildingInspection/components/FeesDataGrid';
import { InspectionVisits } from '@/pages/Tools/BuildingInspection/components/InspectionVisits';
import {
  inspectionHaveVisitViewFields,
  InspectionViewFields,
} from '@/pages/Tools/BuildingInspection/dummy_data/dummy_data';
import FeesModal from '@/pages/Tools/BuildingInspection/modals/FeesModal';
import SiteVisitModal from '@/pages/Tools/BuildingInspection/modals/SiteVisitModal';
import { inspectionsStatusColor } from '@/pages/Tools/BuildingInspection/Models';
import colors from '@/theme/variables/colors';

const ViewInspection = () => {
  const navigate = useNavigate();
  const { searchQuery } = useSearchPersist();
  const { buildingId, inspectionId } = useParams();
  const [showFeesDrawer, setShowFeesDrawer] = useState<boolean>(false);
  const [showVisitDrawer, setShowVisitDrawer] = useState<boolean>(false);
  const { buildingRecords, inspections, inspectionVisits } =
    useBuildingInspectionContext();
  const currentBuilding = buildingRecords.find(
    (record) => record._id === buildingId,
  );
  if (!currentBuilding) {
    return <p>Building not found</p>;
  }
  const currentinspection = inspections.find(
    (inspection) => inspection._id === inspectionId,
  );
  if (!currentinspection) {
    return <p>inspection not found</p>;
  }

  return (
    <Page>
      <PageHeader
        title={
          <p>
            {currentinspection?._id}
            <Chip
              sx={{
                backgroundColor:
                  inspectionsStatusColor[currentinspection.status],
                color: '#fff',
                mx: 1,
                fontSize: '12px',
              }}
              label={currentinspection.status}
              size="small"
            />
            <Chip
              sx={{ backgroundColor: colors.grey[10], mx: 1, fontSize: '12px' }}
              label={`${currentBuilding.name}, ${currentBuilding.streetAddress} ${currentBuilding.city} ${currentBuilding.zipCode}`}
              size="small"
            />
          </p>
        }
        backRoute={`/tools/building-inspection/${buildingId}${searchQuery}`}
      >
        <Button
          variant="contained"
          color="error"
          size="medium"
          onClick={() =>
            navigate(
              `/tools/building-inspection/${buildingId}/start_inspection/${inspectionId}`,
            )
          }
        >
          Begin inspection
        </Button>
      </PageHeader>
      <FormCard title="Inspection information">
        {InspectionViewFields.map((inspection) => (
          <ViewItem
            key={inspection.key}
            label={inspection.label}
            value={currentinspection[
              inspection.key as keyof typeof currentinspection
            ]?.toString()}
            {...inspection.size}
          />
        ))}
        {inspectionVisits.find(
          (visit) => visit.inspection_id === inspectionId,
        ) && (
          <>
            <div style={{ width: '100%' }}></div>
            {inspectionHaveVisitViewFields.map((inspection) => (
              <ViewItem
                key={inspection.key}
                label={inspection.label}
                value={inspection.value}
                {...inspection.size}
              />
            ))}
          </>
        )}
      </FormCard>

      <FormCard title="Unpaid fees" sx={{ flexDirection: 'column' }}>
        <Stack flexDirection="column" ml="16px" sx={{ width: '100%' }}>
          <FeesDataGrid></FeesDataGrid>
          <Button
            variant="contained"
            color="inherit"
            sx={{
              margin: '20px auto 0 0 ',
              backgroundColor: colors.grey[10],
              color: colors.grey[100],
            }}
            onClick={() => setShowFeesDrawer(true)}
          >
            <IcPlus style={{ marginRight: '10px' }} />
            Add another record
          </Button>
        </Stack>
      </FormCard>

      <Button
        sx={{
          position: 'relative',
          margin: '10px 0 -55px auto',
          zIndex: '100',
        }}
        variant="contained"
        color="error"
        onClick={() => setShowVisitDrawer(true)}
      >
        Add site visit
      </Button>
      <InspectionVisits />

      <FeesModal openModal={showFeesDrawer} setOpenModal={setShowFeesDrawer} />
      <SiteVisitModal
        openModal={showVisitDrawer}
        setOpenModal={setShowVisitDrawer}
      />
    </Page>
  );
};

export default ViewInspection;
